export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10009.588b2bf1.jpg";